module.exports = __webpack_public_path__ + "static/img/3562_phase_function_Paper_Points.04eb0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3562_phase_function_Paper_Points.png
// module id = q4C/
// module chunks = 0